import { useParams } from "react-router";
import { MutateCampaignForm } from "../components";
import { Divider } from "../../../../components/Divider";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { useGetCampaign } from "../service/campaign-api";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { SpinnerBlock } from "../../../common/Spinner";

export const EditCampaignPage = () => {
  const { id } = useParams();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: campaign, isLoading } = useGetCampaign(organizationKeyName, id);

  return (
    <RouteFullScreenModal title="Edit campaign">
      <Divider />
      {isLoading ? (
        <SpinnerBlock />
      ) : (
        <MutateCampaignForm campaign={campaign} />
      )}
    </RouteFullScreenModal>
  );
};
